import { render } from "./RecentSearch.vue?vue&type=template&id=4903d26f&scoped=true"
import script from "./RecentSearch.vue?vue&type=script&lang=js"
export * from "./RecentSearch.vue?vue&type=script&lang=js"

import "./RecentSearch.vue?vue&type=style&index=0&id=4903d26f&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4903d26f"]])

export default __exports__